import { Button, Col, Row } from 'antd';
import React from 'react';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';
import QuestionItem from './QuestionItem';

const QuestionList = ({ summaryHandler }) => {
  return (
    <Row className='patient-landing-container mt-30 mr-20 ml-20 mb-30' justify='center'>
      <Col span={24}>
        <h2 className="mb-10 text-center">Revisa tus respuestas</h2>
      </Col>
      <Col span={24}>
        <h3 className="mb-0 text-center text-orange pl-60 pr-60">Cuestionario<br />{summaryHandler.currentSurvey?.name}</h3>
      </Col>
      {
        summaryHandler.currentSurvey?.questions.map(question =>
          <QuestionItem key={question.question_id} summaryHandler={summaryHandler} question={question}></QuestionItem>
        )
      }
      {
        summaryHandler.currentSurveyIndex - 1 >= 0 &&
        <Col span={24} className='mt-30'>
          <Row className='text-center' justify='center'>
            <Col span={24} sm={14} md={14} lg={14}>
              <Button
                className='cmt-button primary outline'
                type="primary"
                size='large'
                block
                onClick={summaryHandler.prevSurvey}
              >
                Anterior
              </Button>
            </Col>
          </Row>
        </Col>
      }
      <Col span={24} className={`${summaryHandler.currentSurveyIndex - 1 < 0 ? 'mt-30' : 'mt-15'}`}>
        <Row className='text-center' justify='center'>
          <Col span={24} sm={14} md={14} lg={14}>
            <Button
              className='cmt-button primary'
              type="primary"
              size='large'
              block
              onClick={summaryHandler.nextSurvey}
              loading={summaryHandler.loading}
            >
              {
                (summaryHandler.surveys && summaryHandler.currentSurveyIndex + 1 >= summaryHandler.surveys.length) ?
                  'Finalizar' :
                  'Siguiente'
              }
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24} className='mt-30'>
        <ByMuvu />
      </Col>
    </Row>
  )
}

export default QuestionList;